import axios from 'axios'
import React from 'react'
import { swalInfo } from '../../../common/components/Swaler'

var check = (packageId) => {
    fetch(`${window.MYQLOCX_API}/subject/admin/bi/deliverystatus/${packageId}`, {
        method: 'get',
        headers: axios.defaults.headers.common
    }).then(t => t.json()).then(t => {
        var msg
        if (t._id) {
            if (t.isObservableMatch === true) {
                msg = '- Leveransen är registrerad som OBSERVERBAR i Qlocx system'
            } else {
                msg = "- Leveransen är registererad i Qlocx system"
            }
        }
        if (t.checkout && !!t.checkout.date) msg += "<br/>- Leveransen har blivit avlevererad"

        if (msg) return swalInfo("", msg)

        swalInfo("", "Leveransen fick ej match")
    })
}

const packageIdCheck = ({ packageId }) => {
    return <button onClick={() => check(packageId)}>Check</button>
}

export default packageIdCheck